import {
  ActivityStatusEnum,
  ActivityTypeEnum,
  TUserActivity,
} from '@/apis/promotions';
import useTheme from '@/theme/useTheme';
import { Box, Stack, Typography } from '@mui/material';
import { TFunction, useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';
import reloadSwapBanner from './assets/reload_swap_banner.png';
import ActivityCardItem from './components/activity-card-item';
import BonusCardItem from './components/bonus-card-item';
import { TInferSchemaType } from '@/constants/schemas';
import { SRewardItem } from '@/apis/rewards';
import ActiveDepositeBonusDetails from '@/components/biz/rewards/ActiveDepositeBonusDetails';

const getButtontext = (status: number, t: TFunction) => {
  switch (status) {
    case -1:
      return t('Unavailable');
    case 0:
      return t('Get Freespin');
    case 2:
      return t('OnGoing');
    case 3:
      return t('Claimed');
    default:
      return t('Unavailable');
  }
};

const GeneralBonus: React.FC<{
  activities: TUserActivity[];
  rewards: TInferSchemaType<typeof SRewardItem>[];
}> = ({ activities, rewards = [] }) => {
  const { theme } = useTheme();

  const [t] = useTranslation();

  const depositBonus = activities.find(
    (activity) => activity.activityType === ActivityTypeEnum.WELCOME_BONUS,
  );

  const reloadBonus = activities.find(
    (a) => a.activityType === ActivityTypeEnum.RELOAD,
  );
  const restBonus = activities.filter(
    (a) =>
      a.activityType !== ActivityTypeEnum.RELOAD &&
      a.activityType !== ActivityTypeEnum.WELCOME_BONUS,
  );

  return (
    <Stack gap={2}>
      <Box
        display={'grid'}
        gridTemplateColumns={[
          'repeat(1, 1fr)',
          'repeat(1, 1fr)',
          'repeat(2, 1fr)',
          'repeat(3, 1fr)',
        ]}
        alignItems={'stretch'}
        gap={2}
      >
        <Box
          gridColumn={[undefined, undefined, 'span 2']}
          display={'flex'}
          position={'relative'}
          flexDirection={'column'}
          sx={{
            '& > img': {
              display: ['none', 'none', 'none', 'block'],
            },
          }}
        >
          <Typography
            padding={1}
            display={reloadBonus || depositBonus ? 'inline' : 'none'}
            color={theme.palette.grey['1000']}
            sx={{
              background: theme.palette.primary.light,
              alignSelf: 'flex-start',
              borderTopRightRadius: theme.spacing(1),
            }}
          >
            {reloadBonus ? (
              reloadBonus.status === ActivityStatusEnum.FINISHED ? (
                <>{t('MoonClub Rewards')}</>
              ) : (
                <>
                  {t('Thursday Reload Bonus')}&nbsp;(
                  {(Number(reloadBonus.totalBonusAmount) /
                    Number(reloadBonus.depositAmount) || 1) * 100}
                  %)
                </>
              )
            ) : depositBonus ? (
              <>
                {t('Welcome Bonus')}(
                {Number((depositBonus as any).multiplier) * 100}%)
              </>
            ) : null}
          </Typography>
          {reloadBonus ? (
            <ActivityCardItem activity={reloadBonus} />
          ) : depositBonus &&
            (depositBonus as any).currentInProgressIndex >= 0 ? (
            <ActiveDepositeBonusDetails
              depositBonusDetail={depositBonus as any}
            />
          ) : (
            <Image src={reloadSwapBanner.src} alt="banner" fill />
          )}
        </Box>

        {rewards
          .filter(
            (r) =>
              r.bonus === 'WEEKLY' ||
              r.bonus === 'MONTHLY' ||
              r.bonus === 'RAKEBACK',
          )
          .map((r) => (
            <BonusCardItem
              key={r.bonus}
              bonus={r}
              mt={
                r.bonus === 'RAKEBACK' &&
                ((depositBonus && depositBonus.currentInProgressIndex >= 0) ||
                  reloadBonus)
                  ? 5
                  : 0
              }
            />
          ))}

        {restBonus.map((activity) => {
          return (
            <ActivityCardItem key={activity.activityId} activity={activity} />
          );
        })}
      </Box>
    </Stack>
  );
};

export default GeneralBonus;
